// eslint-disable-next-line simple-import-sort/imports
import { RadioGroup } from '@/components/RadioGroup';
import {
    selectVehicleAssetType,
    setVehicleAssetType,
    EVehicleAssetType,
} from '@/context/borrower';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { getEnumValueFromString } from '@/utils/getEnumValueFromString';

export interface IProps {
    baseId: string;
    showErrors: boolean;
}

export const testId = 'AssetTypeSelector';

export function AssetTypeSelector({ baseId, showErrors }: IProps): JSX.Element {
    // ***** Redux *****
    const currentState = useAppSelector(selectVehicleAssetType);
    const dispatch = useAppDispatch();

    // ***** Event Handlers *****
    function handleChange(value: string | boolean | undefined): void {
        if (value) {
            const enumValue = getEnumValueFromString(
                EVehicleAssetType,
                value
            ) as EVehicleAssetType;
            dispatch(setVehicleAssetType(enumValue));
        }
    }

    // ***** Render *****
    const options = [
        {
            label: 'Caravan',
            value: EVehicleAssetType.CARAVAN,
            id: `${baseId}-button-assetType-caravan`,
        },
        {
            label: 'Car',
            value: EVehicleAssetType.PASSENGER_VEHICLE,
            id: `${baseId}-button-assetType-car`,
        },
    ];
    return (
        <div data-testid={testId} className='w-full py-2'>
            <RadioGroup
                title='What type of asset are you looking to finance?'
                showErrors={showErrors}
                onChange={handleChange}
                options={options}
                value={currentState}
                tooltipContent='Select the type of asset you want to finance.'
            />
        </div>
    );
}
